'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.openBiddableModal = exports.biddableTransactionCompleted = exports.isInstantApprovalEnabled = exports.ESCROW_DEPOSIT_SENT = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _helpers = require('../api/remote/helpers');

var _reselect = require('reselect');

var _modal = require('./modal');

var _user = require('./user');

var _config = require('../modules/config');

var _intl = require('./intl');

var _browser = require('./browser');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var ESCROW_DEPOSIT_SENT = exports.ESCROW_DEPOSIT_SENT = 'la/user/biddable/ESCROW_DEPOSIT_SENT';

// reducer
var DEFAULT_STATE = {
    instantApprovalEnabled: false
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case ESCROW_DEPOSIT_SENT:
            return (0, _extends3.default)({}, state);
        default:
            return state;
    }
}

var getForceInstantApprovalEnabled = function getForceInstantApprovalEnabled() {
    return typeof window === 'undefined' ? false : window.forceInstantApprovalEnabled;
};
var getInstantDepositWidget = function getInstantDepositWidget() {
    return typeof window === 'undefined' ? false : window.InstantDepositWidget;
};

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.user.biddable;
};
var isInstantApprovalEnabled = exports.isInstantApprovalEnabled = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.instantApprovalEnabled;
});

/* Action Creators */
var biddableTransactionCompleted = exports.biddableTransactionCompleted = function biddableTransactionCompleted() {
    return { type: ESCROW_DEPOSIT_SENT };
};
var openBiddableModal = exports.openBiddableModal = function openBiddableModal(catalogId) {
    return function (dispatch, getState) {
        var state = getState();

        var isMobile = !!(0, _browser.isUiMobile)(state);
        var hideInstantApproval = !(isInstantApprovalEnabled(state) || getForceInstantApprovalEnabled());

        if (hideInstantApproval || isMobile) {
            return _promise2.default.resolve();
        }

        var InstantDepositWidget = getInstantDepositWidget();
        if (!InstantDepositWidget) {
            return _promise2.default.reject(new Error('Instant approval is turned on but no biddable integration was found.'));
        }

        var authToken = (0, _user.getAuthToken)(state);
        var deployment = (0, _config.getDeployment)(state);
        var depositUrl = (0, _helpers.buildUrl)('<ESCROW-API>', deployment, 'deposit');
        try {
            var widget = new InstantDepositWidget({
                brandingCssOptions: {
                    // Defines the accent color (default: #D43E85)
                    brandColor: '#0097BA',
                    // Defines the button border radius (default: 4px)
                    buttonBorderRadius: '2px'
                },
                callback: function callback() {
                    var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
                    var result = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

                    if (error) {
                        console.log(error);
                    }
                    dispatch(biddableTransactionCompleted());
                },
                data: {
                    catalogId: catalogId,
                    creationTxValue: '1336950000000001',
                    token: authToken
                },
                depositUrl: depositUrl,
                languange: (0, _intl.getLocale)(state) || 'en',
                links: {
                    blockinfo: '#',
                    buyTokens: '#',
                    faq: '#'
                },
                platformName: 'LiveAuctioneers'
            });

            // close all of the other modals just in case
            dispatch((0, _modal.dismissModal)());

            widget.openPopup();
            return _promise2.default.resolve();
        } catch (e) {
            return _promise2.default.reject(e);
        }
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/biddable.js
// module id = g3g9
// module chunks = 57